export const INIT_START = 'INIT_START';
export const INIT_SUCCESS_ONLINE = 'INIT_SUCCESS_ONLINE';
export const INIT_SUCCESS_OFFLINE = 'INIT_SUCCESS_OFFLINE';
export const OFFLINE_CHANGE = 'OFFLINE_CHANGE';
